import { Box } from "@mui/material";

import { IconSprite } from "../../ui/IconSprite/IconSprite";

import {
  AccordionStyled,
  Details,
  Summary,
  Wrapper,
} from "./FaqAccordion.styled";

const CustomExpandIcon = () => (
  <Box>
    <div className="icon-accordion">
      <IconSprite tag="faqCircleIcon" width="14" height="14" />
    </div>
  </Box>
);

export const FaqAccordion = ({ faqData }) => (
  <Wrapper itemScope itemType="https://schema.org/FAQPage">
    {faqData?.map(({ question, answer }, ind) => (
      <AccordionStyled key={ind} defaultExpanded={ind === 0}>
        <Summary
          aria-controls={`panel${ind}-content`}
          id={`panel${ind}-header`}
          itemScope
          itemProp="mainEntity"
          itemType="https://schema.org/Question"
          expandIcon={<CustomExpandIcon />}
        >
          {question}
        </Summary>

        <Details
          itemScope
          itemProp="acceptedAnswer"
          itemType="https://schema.org/Answer"
        >
          {answer}
        </Details>
      </AccordionStyled>
    ))}
  </Wrapper>
);
